module.exports = __webpack_public_path__ + "img/info.58d7383e.png";